import React, {useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";

import {CONTENT_TYPES} from "./assignQuoteConstants";
import {getSelectedContracts, shouldForceContractSigningForHomeDepotReceipt} from "../contractSign/contractsFunctions";
import Misc from "../../../misc/misc";
import LoadingSpinner from "../../ui/loadingSpinner";
import Config from "../../../config";
import {isForceSaveQuoteFailureEnabled, setForceSaveQuoteFailureEnabled} from "../../../misc/errorReporting/devToolsState";

const getSelectedContractString = (fabricatorData, contractsList) => {
  if (!fabricatorData.settings.useContractSigning || (contractsList.length <= 1)) { // if only one - we are hiding block
    return ""
  }
  let selectedContracts = getSelectedContracts(contractsList);
  if (fabricatorData.isAmericanStandard) {
    selectedContracts = selectedContracts.filter((cont, contIndex) => contIndex !== 0);
  }
  if (!selectedContracts.length) {
    return ""
  }
  if (selectedContracts.length === 1) {
    return Misc.textSubStringEllipsis(selectedContracts[0].name, 36) || "Noname contract";
  } else {
    return selectedContracts.length + " Contracts Selected";
  }
}

const AssignQuotePopupTopButtons = (props) => {

  const {contentType, changeContent, fabricatorData, contractsList, contractsReceived, assignQuotePopupSaveButtons,
    fromAI} = props;

  let activeContractName = getSelectedContractString(fabricatorData, contractsList);

  const showContractButton = contentType !== CONTENT_TYPES.contractSelect && fabricatorData.settings.useContractSigning
    && (contractsList.length > 1) && (assignQuotePopupSaveButtons !== "save") && !fromAI;

  const weCanGoToSignWithoutSelectedContract = shouldForceContractSigningForHomeDepotReceipt();

  const canShowDevTools = Config.isDevMode();

  // Real checkbox, real persistent state: while checked, the actual Save
  // Quote / Sign button below runs saveQuote() with a synthetic 403 instead
  // of hitting the network. Nothing fires until that real button is clicked.
  const [forceSaveFail, setForceSaveFail] = useState(isForceSaveQuoteFailureEnabled());

  const handleForceSaveFailChange = (event) => {
    setForceSaveFail(event.target.checked);
    setForceSaveQuoteFailureEnabled(event.target.checked);
  };

  return (
    <div className="flex flex--center flex--end u-pl-125 u-pr-125 u-pt-05">
      {showContractButton ? (
        <div className="flex flex--center flex--1">
          {!contractsReceived ? <LoadingSpinner size="40"/> : (
            <span className={"flex--1 bold secondary flex flex--center height-100" + (activeContractName ? " blue" : " red")
              + (activeContractName ? " break-word" : "")}>
                  {weCanGoToSignWithoutSelectedContract ? null : (activeContractName || "* Assigned Contract Required")}
                </span>
          )}
          <button className="ui-button2 ui-button2--green margin-r-8" onClick={() => {
            changeContent(CONTENT_TYPES.contractSelect)
          }}>
            <FormattedMessage id="assignPopup.assignContract"/>
          </button>
        </div>
      ) : null}
      {contentType === CONTENT_TYPES.searchCustomer || contentType === CONTENT_TYPES.shippingEdit ? (
        <button className="ui-button2 ui-button2--green ui-button2--green-plus ass-content-button"
                onClick={() => changeContent(CONTENT_TYPES.newCustomer)}>
          <FormattedMessage id="assignPopup.addCustomerButton"/>
        </button>
      ) : null}
      {canShowDevTools ? (
        <label className="dev-tools__force-fail-toggle margin-l-8"
               title="Dev only: while checked, the Save Quote / Sign button below fails with a real 403">
          <input type="checkbox" checked={forceSaveFail} onChange={handleForceSaveFailChange}/>
          Force save fail (403)
        </label>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {contractsList, contractsReceived} = store.contractSigningState;
  const {assignQuotePopupSaveButtons} = store.assignQuoteState;

  return {
    assignQuotePopupSearchText: store.assignQuoteState.assignQuotePopupSearchText,
    fabricatorData: store.fabricatorState,
    contractsList,
    contractsReceived,
    assignQuotePopupSaveButtons,
  };
};

const mapDispatchToProps = {};

export default (
  connect(mapStateToProps, mapDispatchToProps)(AssignQuotePopupTopButtons)
)
